import "./Column.css"
const Column = ({children}) =>{
    return <div className="column">{children}</div>
}

export default Column;
